/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect } from "react";
import { Grid, Stack, TextField, Button, capitalize } from "@mui/material";
import { AppContext } from "../../context/AppProvider";
import { ConfiguratorForm } from "./Form";

const styles = {
  details: {
    width: "100%",

  }
};

export const Configurator = (props) => {
  const { configuration, pricing, setPromotion, resetPromotion, fetchPrices } = useContext(AppContext);
  const { arePromotionsAllowed, promotion, pricePerUser, pricePerMonth, pricePerYear, pricePerVpnSeat } = configuration;
  const { discount } = pricing;

  useEffect(() => {
    fetchPrices();
  }, []);

  return (
    <Grid container>
      <Grid item md={6} className="form">
        <ConfiguratorForm />
      </Grid>

      <Grid item md={6} className="summary">
        <div className="summary-holder">
        <div className="summary-box" style={styles.details}>
          <div className="title">{ capitalize(configuration.sku) } <span>Annual Payment</span> <div>${pricePerMonth}<span>/mo</span></div></div>
          <p>Kasm Workspaces Starter Subscription (Self-Supported)</p>
        </div>
        <div className="summary-table">
            <div className="line"><span>Price per user/month</span><span>${pricePerUser}</span></div>
            { configuration.vpnSeats > 0 && <div className="line"><span>PureVPN Egress per seat/month</span><span>${pricePerVpnSeat}</span></div>}
            <div className="line"><span>Total users</span><span>x{configuration.seats}</span></div>
            { configuration.vpnSeats > 0 && <div className="line"><span>Total PureVPN seats</span><span>x{configuration.vpnSeats}</span></div>}
            <div className="line"><span>Total per month</span><span>${pricePerMonth}</span></div>
            { promotion && discount && <div className="line"><span>Discount applied</span><span>{discount * 100}%</span></div>}
            <div className="line total"><span>Total <span className="sub">(billed annually)</span></span><span>${pricePerYear}</span></div>
          </div>

          {arePromotionsAllowed ? (
            <Stack direction="row" spacing={1} alignItems="center">
              <TextField
                value={promotion}
                disabled={!!discount}
                onChange={(e) => setPromotion(e.target.value)}
                variant="outlined"
                size="small"
                margin="dense"
                placeholder="Promo code"
                inputProps={{ maxLength: 10 }}
                sx={{background: 'white', borderRadius: '10px'}}
              />
              { !discount
                ? <Button disabled={!promotion} onClick={fetchPrices}>Apply</Button>
                : <Button onClick={resetPromotion}>Reset</Button>
              }
            </Stack>
          ) : null}
        </div>
      </Grid>
    </Grid>
  );
}